var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconlyBrokenStar3C2Feada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Broken_Star",
    "data-name": "Iconly/Broken/Star",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.678,
    height: 30.689,
    viewBox: "0 0 30.678 30.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star-2",
    "data-name": "Star",
    d: "M23.778,30.562a1.028,1.028,0,0,1-.54-.138l-7.883-4.152L8.414,30.009a2.334,2.334,0,0,1-3.164-.941c-.008-.014-.015-.028-.023-.043a2.516,2.516,0,0,1-.242-1.534l1.35-7.969L.692,13.809a2.456,2.456,0,0,1,0-3.417A2.292,2.292,0,0,1,2.042,9.7L9.779,8.525l3.441-7.17a2.325,2.325,0,0,1,4.225,0L20.9,8.55l7.763,1.189a2.34,2.34,0,0,1,1.559.957,2.53,2.53,0,0,1-.249,3.193l-5.617,5.646.782,4.294a1.2,1.2,0,0,1-.959,1.381,1.163,1.163,0,0,1-1.35-.941l-.8-4.294a2.49,2.49,0,0,1,.675-2.16l5.631-5.686-7.763-1.2A2.332,2.332,0,0,1,18.81,9.544L15.355,2.38l-3.5,7.277a2.328,2.328,0,0,1-1.769,1.381L2.35,12.213,7.939,17.89a2.441,2.441,0,0,1,.675,2.131L7.264,27.99l6.94-3.722a2.258,2.258,0,0,1,2.214,0L24.29,28.42a1.209,1.209,0,0,1,.594,1.349,1.181,1.181,0,0,1-1.134.921Z",
    transform: "translate(0 0)",
    fill: "#f6cf58"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyBrokenStar3C2Feada);
export default __webpack_public_path__ + "static/media/Iconly-Broken-Star.3c2feada.3c2feadaef9d25ba214cd00446bc23ef.svg";
export { ForwardRef as ReactComponent };